
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

(function() {
	
	document.addEventListener('pageLoad', () => {
		if(! document.getElementById('splash-screen') ) {
			return;
		}
		gsap.set('#splash-screen', { opacity: 0 });
		gsap.set('#splash-screen .screen--figure', { opacity: 0, y: 100 });
		gsap.set('#splash-screen .screen--main', { opacity: 0, y: 32 });
		gsap.set('#splash-screen .screen--footer', { opacity: 0 });
	
		let tl = gsap.timeline();	
		tl.to('#splash-screen', { opacity:1, duration: 1 });
		tl.to('#splash-screen .screen--figure', { y: 0, opacity:1, duration: 1, delay: -.75 });
		tl.to('#splash-screen .screen--main', { y: 0, opacity:1, duration: .75, delay: -.75 });
		tl.to('#splash-screen .screen--footer', { opacity:1, duration: .75, delay: -.75 });
	
		
		let tls = gsap.timeline({
			scrollTrigger: {
				trigger: '#splash-screen',
				//pin: true,
				pin:false,
				start: 'bottom bottom',
				//end: "+=500", // end after scrolling 500px beyond the start
				scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
				/*
				snap: {
					duration: { min: 0.2, max: 3 }, // the snap animation should be at least 0.2 seconds, but no more than 3 seconds (determined by velocity)
					delay: 0.2, // wait 0.2 seconds from the last scroll event before doing the snapping
					ease: "power1.inOut", // the ease of the snap animation ("power3" by default)
				},
				*/
			},
		});
		
		tls.to('#splash-screen .screen--figure', { opacity:0, duration: 2, scale:.5 });
		tls.to('#splash-screen .screen--main', { opacity:0, duration: 2, scale:.9, delay:-1 });
		tls.to('#splash-screen .screen--footer', { opacity:0, duration: 2, scale:.9, delay:-1 });
		tls.to('#splash-screen', { opacity:.7, duration: 2 });
	});
})();





(function() {
	document.addEventListener('pageLoad', () => {
		if(! document.getElementById('screen-apps') ) {
			return;
		}
		
		gsap.set('#screen-apps', { opacity: 0 });
		gsap.to('#screen-apps .app', { y: 32, opacity: 0 });
	
		let tl = gsap.timeline({
			scrollTrigger: {
				trigger: '#screen-apps',
				//pin: true, // pin the trigger element while active
				start: "top center",
				end: "top top",//25%", // end after scrolling 500px beyond the start
				scrub: 1, 
			},
		});
		
		tl.to('#screen-apps', { opacity:1, duration: 2 });
		
		tl.to('#screen-apps .app', {
			y: 0,
			opacity:1,
			duration:2,
			delay:1,
			stagger: .25, // 0.1 seconds between when each ".box" element starts animating
		});
	});
})();
